/* HERRENLAGER - gift auto-add (E-Book), tier bar, FAQ, reels, cart offers */
(function () {
var GIFT = 58922982539647;
var origFetch = window.fetch.bind(window);
var LV_HDR = { 'Content-Type': 'application/json', 'X-LV': '1' };
function getCart() { return origFetch('/cart.js', { headers: { 'X-LV': '1' } }).then(function (r) { return r.json(); }); }
function giftLine(cart) { return cart.items.filter(function (i) { return i.variant_id === GIFT; })[0]; }
function paidCount(cart) { return cart.items.reduce(function (n, i) { return n + (i.variant_id === GIFT ? 0 : i.quantity); }, 0); }
function isAdd(u) { return /\/cart\/add(\.js)?(\?|$)/.test(u); }
function isChange(u) { return /\/cart\/(change|update)(\.js)?(\?|$)/.test(u); }
window.fetch = function (input, init) {
var url = typeof input === 'string' ? input : (input && input.url) || '';
var mine = init && init.headers && (init.headers['X-LV'] || (init.headers.get && init.headers.get('X-LV')));
if (mine) return origFetch(input, init);
if (isAdd(url)) {
return getCart().then(function (cart) {
if (giftLine(cart)) return;
return origFetch('/cart/add.js', { method: 'POST', headers: LV_HDR, body: JSON.stringify({ items: [{ id: GIFT, quantity: 1 }] }) }).catch(function () {});
}).catch(function () {}).then(function () { return origFetch(input, init); })
.then(function (res) { setTimeout(refreshTier, 400); return res; });
}
if (isChange(url)) {
return origFetch(input, init).then(function (res) {
getCart().then(function (cart) {
var g = giftLine(cart);
if (g && paidCount(cart) === 0) {
origFetch('/cart/change.js', { method: 'POST', headers: LV_HDR, body: JSON.stringify({ id: g.key, quantity: 0 }) }).then(function () { location.reload(); });
} else if (g && g.quantity > 1) {
origFetch('/cart/change.js', { method: 'POST', headers: LV_HDR, body: JSON.stringify({ id: g.key, quantity: 1 }) }).then(function () { location.reload(); });
} else { setTimeout(refreshTier, 400); }
});
return res;
});
}
return origFetch(input, init);
};
/* ---------- Quantity discount progress bar (cart + drawer) ---------- */
/* 1-2 items = 10% (welcome discount, applied automatically) | 3+ items = 15% */
function tierHTML(n) {
var lvl = n >= 3 ? 2 : 1;
var more = 3 - n;
var txt = '🎉 You unlocked the <strong>maximum 15% discount</strong>';
if (lvl === 1) txt = 'Your <strong>10% discount</strong> is applied. Add <strong>' + more + ' more item' + (more > 1 ? 's' : '') + '</strong> to unlock <strong>15% off</strong>';
var POS = [10, 90];
var fill = lvl === 2 ? 100 : (n === 2 ? 50 : POS[0]);
var h = '<div class="lv-tierbar"><p class="lv-tierbar__text">' + txt + '</p><div class="lv-tierbar__track"><div class="lv-tierbar__fill" style="width:' + fill + '%"></div>';
['1', '3+'].forEach(function (lbl, i) { h += '<span class="lv-tierbar__node' + (lvl >= i + 1 ? ' is-reached' : '') + '" style="left:' + POS[i] + '%">' + lbl + '</span>'; });
h += '</div><div class="lv-tierbar__labels">';
[['-10%', 1], ['-15%', 2]].forEach(function (l, i) { h += '<span class="lv-tierbar__label' + (lvl >= l[1] ? ' is-reached' : '') + '" style="left:' + POS[i] + '%">' + l[0] + '</span>'; });
return h + '</div></div>';
}
function refreshTier() {
getCart().then(function (cart) {
var n = paidCount(cart);
document.querySelectorAll('.lv-tierbar-wrap').forEach(function (x) { x.remove(); });
document.querySelectorAll('cart-drawer .lv-tierbar').forEach(function (x) { x.remove(); });
if (cart.item_count === 0) return;
document.querySelectorAll('cart-drawer .drawer__header').forEach(function (a) { a.insertAdjacentHTML('afterend', tierHTML(n)); });
var page = document.getElementById('main-cart-items') || document.querySelector('cart-items.page-width');
if (page && !page.closest('cart-drawer')) page.insertAdjacentHTML('beforebegin', '<div class="lv-tierbar-wrap" style="margin:0 0 16px">' + tierHTML(n) + '</div>');
}).catch(function () {});
}
document.addEventListener('DOMContentLoaded', function () {
refreshTier();
var drawer = document.querySelector('cart-drawer');
if (drawer) new MutationObserver(function (m) {
if (m.some(function (x) { return Array.prototype.some.call(x.addedNodes, function (nd) { return nd.nodeType === 1 && !nd.classList.contains('lv-tierbar') && !nd.classList.contains('lv-co') && !(nd.closest && (nd.closest('.lv-tierbar') || nd.closest('.lv-co'))); }); })) { clearTimeout(window.__lvT); window.__lvT = setTimeout(refreshTier, 150); }
}).observe(drawer, { childList: true, subtree: true });
});
/* ---------- FAQ accordion ---------- */
document.addEventListener('click', function (e) {
var q = e.target.closest('.loravienne-faq__question');
if (!q) return;
var ans = q.nextElementSibling, open = q.getAttribute('aria-expanded') === 'true';
q.setAttribute('aria-expanded', open ? 'false' : 'true');
ans.style.maxHeight = open ? '0px' : ans.scrollHeight + 'px';
});
/* ---------- Reels player ---------- */
document.addEventListener('click', function (e) {
var card = e.target.closest('[data-lv-open]');
if (card) { openPlayer(card.closest('.lv-reels'), +card.dataset.lvOpen); return; }
});
function openPlayer(root, idx) {
var p = document.getElementById(root.dataset.player); if (!p) return; if (p.parentElement !== document.body) document.body.appendChild(p);
var vids = JSON.parse(root.dataset.videos), v = p.querySelector('video'), i = idx;
function show() { v.src = vids[i]; v.play().catch(function () {}); p.querySelector('[data-prev]').disabled = i === 0; p.querySelector('[data-next]').disabled = i === vids.length - 1; }
p.classList.add('is-open'); document.body.style.overflow = 'hidden'; show();
p.onclick = function (e) {
if (e.target.closest('[data-close]')) { v.pause(); p.classList.remove('is-open'); document.body.style.overflow = ''; }
else if (e.target.closest('[data-prev]') && i > 0) { i--; show(); }
else if (e.target.closest('[data-next]') && i < vids.length - 1) { i++; show(); }
else if (e.target.closest('[data-sound]')) { v.muted = !v.muted; p.classList.toggle('is-unmuted', !v.muted); }
else if (e.target.closest('[data-shop]')) { v.pause(); p.classList.remove('is-open'); document.body.style.overflow = ''; var b = document.querySelector('.product-form__submit'); if (b) b.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
};
}
})();
/* ---------- HERRENLAGER cart offers: quantity upsell + cross-sell (drawer + cart page) ---------- */
(function () {
var GIFT = 58922982539647;
var SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', '4XL', '5XL'];
var recCache = {};
function money(c) {
var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(c / 100); } catch (e) { return '$' + (c / 100).toFixed(2); }
}
function esc(s) { return String(s || '').replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
function getCart() { return fetch('/cart.js', { headers: { 'X-LV': '1' } }).then(function (r) { return r.json(); }); }
/* Shared add-to-cart used by PDP cross-sell and cart offers */
window.lvAdd = function (id, qty, btn) {
if (btn) { btn.disabled = true; btn.dataset.t = btn.textContent; btn.textContent = 'Adding...'; }
var hasDrawer = !!document.querySelector('cart-drawer');
var body = { items: [{ id: +id, quantity: qty || 1 }] };
if (hasDrawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = location.pathname; }
return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
.then(function (r) { return r.json(); })
.then(function (j) {
if (j && j.status && j.status >= 400) throw new Error(j.description || 'error');
var d = document.querySelector('cart-drawer');
if (location.pathname.replace(/\/$/, '') === '/cart') { location.reload(); }
else if (d && typeof d.renderContents === 'function' && j.sections) {
j.id = +id; d.classList.remove('is-empty'); d.renderContents(j);
} else { location.href = '/cart'; }
if (btn) { btn.textContent = 'Added'; setTimeout(function () { btn.disabled = false; btn.textContent = btn.dataset.t; }, 1500); }
})
.catch(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.t; } location.href = '/cart'; });
};
function paid(cart) { return cart.items.filter(function (i) { return i.variant_id !== GIFT; }); }
function sizeOf(title) {
var parts = String(title || '').split('/').map(function (t) { return t.trim().toUpperCase(); });
for (var i = 0; i < parts.length; i++) if (SIZES.indexOf(parts[i]) > -1) return parts[i];
return null;
}
function recs(pid) {
if (recCache[pid]) return Promise.resolve(recCache[pid]);
return fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related', { headers: { 'X-LV': '1' } })
.then(function (r) { return r.json(); })
.then(function (j) { recCache[pid] = (j && j.products) || []; return recCache[pid]; })
.catch(function () { return []; });
}
function crossHTML(list, size, max) {
var out = '';
list.slice(0, max).forEach(function (p) {
var vars = (p.variants || []).filter(function (v) { return v.available; });
if (!vars.length) return;
var pick = vars[0];
if (size) vars.forEach(function (v) { if (sizeOf(v.title) === size && pick === vars[0]) pick = v; });
var sel = vars.length === 1 && vars[0].title === 'Default Title'
? '<input type="hidden" class="lv-co__sel" value="' + vars[0].id + '">'
: '<select class="lv-co__sel" aria-label="Choose option">' + vars.map(function (v) { return '<option value="' + v.id + '"' + (v === pick ? ' selected' : '') + '>' + esc(v.title) + '</option>'; }).join('') + '</select>';
var img = p.featured_image ? (p.featured_image.indexOf('?') > -1 ? p.featured_image + '&width=320' : p.featured_image + '?width=320') : '';
out += '<div class="lv-co__card"><a class="lv-co__img" href="' + esc(p.url) + '"><img src="' + esc(img) + '" alt="" width="140" height="140" loading="lazy"></a>' +
'<a class="lv-co__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
'<span class="lv-co__price">' + money(p.price) + (p.compare_at_price > p.price ? ' <s>' + money(p.compare_at_price) + '</s>' : '') + '</span>' +
sel + '<button type="button" class="lv-co__btn" data-lv-co-sel>+ Add</button></div>';
});
return out;
}
var CSS = '.lv-co{margin:18px 0 8px}' +
'.lv-co__head{font-size:14px;line-height:1.35;font-weight:600;color:#1E241C;margin:0 0 10px}' +
'.lv-co__rail{display:flex;gap:10px;overflow-x:auto;scroll-snap-type:x proximity;-webkit-overflow-scrolling:touch;padding:0 0 6px;scrollbar-width:none}.lv-co__rail::-webkit-scrollbar{display:none}' +
'.lv-co__card{flex:0 0 138px;scroll-snap-align:start;display:flex;flex-direction:column;gap:4px;padding:8px;border:1px solid #E6E3DC;border-radius:8px;background:#fff}' +
'.lv-co__img{display:block;background:#F1EFEA;border-radius:6px;overflow:hidden}.lv-co__img img{width:100%;height:auto;aspect-ratio:1/1;object-fit:cover;display:block}' +
'.lv-co__title{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;font-size:12px;line-height:1.3;color:#1E241C;text-decoration:none;min-height:31px}' +
'.lv-co__price{display:block;font-size:12px;font-weight:600}.lv-co__price s{font-weight:400;color:#8a8a8a}' +
'.lv-co__sel{width:100%;min-width:0;font:inherit;font-size:11px;padding:4px 4px;border:1px solid #D9D6CE;border-radius:4px;background:#fff}' +
'.lv-co__btn{width:100%;font:inherit;font-size:12px;font-weight:600;padding:7px 8px;border:1px solid #2F3A2C;border-radius:4px;background:#fff;color:#2F3A2C;cursor:pointer;white-space:nowrap;margin-top:auto}.lv-co__btn:hover{background:#2F3A2C;color:#fff}.lv-co__btn[disabled]{opacity:.6}' +
'.lv-co-wrap--page{margin:24px 0 8px}.lv-co-wrap--page .lv-co{margin:0}' +
'@media(min-width:750px){.lv-co-wrap--page .lv-co__card{flex-basis:180px}}';
function render() {
getCart().then(function (cart) {
document.querySelectorAll('.lv-co, .lv-co-wrap').forEach(function (x) { x.remove(); });
var items = paid(cart);
if (!items.length) return;
var n = items.reduce(function (s, i) { return s + i.quantity; }, 0);
var inCart = {}; cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
var size = null; items.forEach(function (i) { size = size || sizeOf(i.variant_title); });
recs(items[0].product_id).then(function (list) {
list = list.filter(function (p) { return !inCart[p.id] && p.available && !/e-book/i.test(p.title); });
if (!document.getElementById('lv-co-css')) { var st = document.createElement('style'); st.id = 'lv-co-css'; st.textContent = CSS; document.head.appendChild(st); }
document.querySelectorAll('.lv-co, .lv-co-wrap').forEach(function (x) { x.remove(); });
function block(max) {
var xs = crossHTML(list, size, max);
if (!xs) return '';
var head = n === 1 ? 'Add 2 more items: with 3 items you get 15% off' : n === 2 ? 'Add another item: with 3 items you get 15% off' : 'Complete your look';
return '<div class="lv-co"><p class="lv-co__head">' + head + '</p><div class="lv-co__rail">' + xs + '</div></div>';
}
var dItems = document.querySelector('cart-drawer cart-drawer-items');
var foot = document.querySelector('cart-drawer .drawer__footer');
if (dItems) dItems.insertAdjacentHTML('beforeend', block(6));
else if (foot) foot.insertAdjacentHTML('beforebegin', block(6));
var page = document.getElementById('main-cart-items');
if (page && !page.closest('cart-drawer')) {
page.insertAdjacentHTML('afterend', '<div class="lv-co-wrap lv-co-wrap--page">' + block(6) + '</div>');
}
});
}).catch(function () {});
}
window.lvRenderCartOffers = render;
document.addEventListener('click', function (e) {
var b = e.target.closest('[data-lv-co-sel]');
if (b) { var s = b.parentNode.querySelector('.lv-co__sel'); window.lvAdd(s.value, 1, b); }
});
document.addEventListener('DOMContentLoaded', function () {
render();
var drawer = document.querySelector('cart-drawer');
if (drawer) new MutationObserver(function (m) {
var relevant = m.some(function (x) { return Array.prototype.some.call(x.addedNodes, function (nd) { return nd.nodeType === 1 && !(nd.closest && (nd.closest('.lv-co') || nd.closest('.lv-tierbar'))) && !(nd.classList && (nd.classList.contains('lv-co') || nd.classList.contains('lv-tierbar'))); }); });
if (relevant) { clearTimeout(window.__lvCo); window.__lvCo = setTimeout(render, 250); }
}).observe(drawer, { childList: true, subtree: true });
var page = document.getElementById('main-cart-items');
if (page && !page.closest('cart-drawer')) new MutationObserver(function (m) {
var relevant = m.some(function (x) { return Array.prototype.some.call(x.addedNodes, function (nd) { return nd.nodeType === 1 && !(nd.closest && (nd.closest('.lv-co') || nd.closest('.lv-co-wrap'))) && !(nd.classList && (nd.classList.contains('lv-co') || nd.classList.contains('lv-co-wrap'))); }); });
if (relevant) { clearTimeout(window.__lvCo2); window.__lvCo2 = setTimeout(render, 300); }
}).observe(page, { childList: true, subtree: true });
});
})();